import { Switch, withRouter, RouteComponentProps } from 'react-router-dom';
import { compose, lifecycle } from 'recompose';
import { withTweekKeys } from 'react-tweek';
import { performanceTimeline } from '@soluto-home-web/platform-utils';
import { UnregisterCallback } from 'history';

type InnerProps = {
  reportPagePerformance: boolean;
} & RouteComponentProps<any>;

export default compose(
  withRouter,
  withTweekKeys({ reportPagePerformance: 'soluto_home_web/metrics/report_page_performance' }),
  lifecycle<InnerProps, { historyListener: UnregisterCallback }>({
    componentDidMount() {
      if (!this.props.reportPagePerformance || !window.performance) return;

      const unregisterHistoryChanges: UnregisterCallback = this.props.history.listen((location, action) => {
        performanceTimeline.startMeasurement(location.pathname);
      });
      this.setState({ historyListener: unregisterHistoryChanges });
    },
    componentWillUnmount() {
      if (!this.state.historyListener) return;
      const unregisterHistoryChanges: UnregisterCallback = this.state.historyListener;
      if (unregisterHistoryChanges) unregisterHistoryChanges();
    },
  })
)(Switch);



// WEBPACK FOOTER //
// ./packages/web-app/src/components/SwitchWithPerformance.ts